import {
  fileExtention,
  fileExtentionMapper,
  fileTypes,
  fileTypesMapper,
} from '@shared/models/enums/files'

export const fileUrl = (file: File) => URL.createObjectURL(file)

export const getFileFromUrl = async (
  dataUrl: string,
  fileName: string,
  fileType: string | fileTypes
): Promise<File> => {
  const res: Response = await fetch(dataUrl)
  const blob: Blob = await res.blob()
  return new File([blob], setFileNameByType(fileName, fileType), {
    type: fileType,
  })
}

export const setFileNameByType = (
  fileName: string,
  fileType: string | fileTypes
) => {
  const extention = getExtensionFromType(fileType)

  const pattern = new RegExp(`\\.${extention}$`, 'i')

  if (!hasExtension(fileName) && !pattern.test(fileName)) {
    return `${fileName}.${extention}`
  }
  return fileName
}

export function hasExtension(filename: string) {
  // Define the regex pattern to match any extension
  const pattern = /[^.]+\.[0-9a-z]+$/i
  return pattern.test(filename)
}

export const getFileType = (mimeType: string) => {
  return mimeType.split('/').pop()
}

export const getExtensionFromType = (type?: string | fileTypes) => {
  if (!type) {
    return null
  }
  return fileExtentionMapper[type as fileTypes] || getFileType(type)
}

export function getFileTypeByName(fileName?: string) {
  if (!fileName) {
    return null
  }
  const ext = fileName.split('.').pop()?.toLowerCase()

  if (!ext) {
    return null
  }

  return fileTypesMapper[ext as fileExtention] || null
}
